module.exports = __webpack_public_path__ + "img/Intrusion_SupervisionRDMP.76c159f1.svg";